import { gql, useMutation } from "@apollo/client";
import React, { useState } from "react";
import { Toast } from "../../../../hooks/toast";

const CHANGE_CUSTOMER_ORDER_ITEM_STATUS = gql`
  mutation changeCustomerOrderItemStatus(
    $uuid: String
    $status: CustomerOrderItemStatus!
  ) {
    changeCustomerOrderItemStatus(uuid: $uuid, status: $status) {
      success
      assignedSlot
    }
  }
`;

export function ScanPackage() {
  const [barcodeInput, setBarcodeInput] = useState("");
  const [changeCustomerOrderItemStatus] = useMutation(CHANGE_CUSTOMER_ORDER_ITEM_STATUS, {
    refetchQueries: ["merchantOrderListBeta"],
    onCompleted: (res) => {
      setBarcodeInput('');
      if(res.changeCustomerOrderItemStatus.success) {
        Toast.onShow("Scan to shippment complete.", "success", "right");
      }
      else {
        Toast.onShow("Cannot scan to shipment", "danger", "right");
      }
    },
  });

  const handleEnterBarcode = (e: any) => {
    if (e.keyCode === 13) {
      changeCustomerOrderItemStatus({
        variables: {
          uuid: barcodeInput,
          status: 'MERCHANT_SHIPPED'
        },
      });
    }
  };

  return (
    <div className="form-group">
      <input
        type="text"
        className="form-control"
        placeholder="SCAN BRACODE BEFORE SENDING"
        style={{
          textAlign: "center",
        }}
        value={barcodeInput}
        onChange={(e) => setBarcodeInput(e.target.value)}
        onKeyDown={handleEnterBarcode}
      />
    </div>
  );
}
